// ====== I18N ===============================================================
const i18nNode = document.querySelector('[data-planetary-calculator-i18n]');
const calculatorI18n = JSON.parse(i18nNode.textContent);
const calculatorLocale = calculatorI18n.locale || document.documentElement.lang;

function interpolate(template, values) {
  return template.replace(/\{(\w+)\}/g, (_, key) => values[key]);
}

// ====== CONFIG dynamique (maj via géoloc) ==================================
let currentLat = 48.8566;
let currentLng = 2.3522;
let TARGET_TZ = 'Europe/Paris';   // mis à jour selon coordonnées
let TARGET_COUNTRY = new Intl.DisplayNames([calculatorLocale], { type: 'region' }).of('FR'); // libellé pays pour l’affichage
let TARGET_CITY = 'Paris';

function cleanEventPayload(payload) {
  return Object.entries(payload).reduce((cleaned, [key, value]) => {
    if (value !== null && value !== undefined && value !== '') {
      cleaned[key] = value;
    }

    return cleaned;
  }, {});
}

function publishNexusEvent(eventName, payload) {
  const publish = window.Shopify?.analytics?.publish;
  if (typeof publish !== 'function') return false;

  try {
    publish.call(window.Shopify.analytics, eventName, cleanEventPayload(payload));
    return true;
  } catch (err) {
    console.warn('Planetary calculator analytics event échoué:', err);
    return false;
  }
}

// ====== Données planétaires ===============================================
const planets = [
  { id: "saturn",  name: calculatorI18n.planets.saturn,  symbol: "♄" },
  { id: "jupiter", name: calculatorI18n.planets.jupiter, symbol: "♃" },
  { id: "mars",    name: calculatorI18n.planets.mars,    symbol: "♂" },
  { id: "sun",     name: calculatorI18n.planets.sun,     symbol: "☉" },
  { id: "venus",   name: calculatorI18n.planets.venus,   symbol: "♀" },
  { id: "mercury", name: calculatorI18n.planets.mercury, symbol: "☿" },
  { id: "moon",    name: calculatorI18n.planets.moon,    symbol: "☾" }
];
const dayRuling = { 0:"sun",1:"moon",2:"mars",3:"mercury",4:"jupiter",5:"venus",6:"saturn" };

// ====== Utils fuseau (DST correct) ========================================
const _tzOffsetCache = new Map();

/** Offset ms pour un fuseau IANA à une date UTC donnée (gère hiver/été). */
function getTimeZoneOffsetMs(dateUtc, timeZone = TARGET_TZ) {
  const key = timeZone + '|' + dateUtc.toISOString().slice(0,19);
  if (_tzOffsetCache.has(key)) return _tzOffsetCache.get(key);
  const dtf = new Intl.DateTimeFormat('en-US', {
    timeZone, timeZoneName: 'shortOffset',
    year:'numeric', month:'2-digit', day:'2-digit',
    hour:'2-digit', minute:'2-digit', second:'2-digit', hour12:false
  });
  const parts = dtf.formatToParts(dateUtc);
  const tzName = parts.find(p=>p.type==='timeZoneName')?.value || 'GMT+0';
  const m = tzName.match(/GMT([+-])(\d{1,2})(?::?(\d{2}))?/);
  const sign = m?.[1] === '-' ? -1 : 1;
  const h = m ? parseInt(m[2],10) : 0;
  const min = m?.[3] ? parseInt(m[3],10) : 0;
  const offset = sign * (h*60 + min) * 60 * 1000;
  _tzOffsetCache.set(key, offset);
  return offset;
}

/** Convertit une Date UTC en “horodatage calé” sur le fuseau cible. */
function toZoned(dateUtc, timeZone = TARGET_TZ) {
  return new Date(dateUtc.getTime() + getTimeZoneOffsetMs(dateUtc, timeZone));
}

/** Format HH:MM dans un fuseau donné. */
function fmtTime(dateUtc, tz) {
  return new Intl.DateTimeFormat(calculatorLocale, { timeZone: tz, hour:'2-digit', minute:'2-digit' }).format(dateUtc);
}

function ordinalHour(n){
  return interpolate(n===1 ? calculatorI18n.ordinalFirst : calculatorI18n.ordinalOther, { number: n });
}
function nextDateStr(s){ const d=new Date(s+'T00:00:00Z'); d.setUTCDate(d.getUTCDate()+1); return d.toISOString().split('T')[0]; }

// ====== Fetch générique avec timeout ======================================
async function fetchJSON(url, opts={}) {
  const c=new AbortController(); const t=setTimeout(()=>c.abort(), opts.timeoutMs||10000);
  try { const r=await fetch(url,{...opts,signal:c.signal}); if(!r.ok) throw new Error(`HTTP ${r.status}`); return await r.json(); }
  finally { clearTimeout(t); }
}

// ====== Services externes (soleil, géoloc, timezone) ======================
async function fetchSun(dateStr){
  const u=`https://api.sunrise-sunset.org/json?lat=${currentLat}&lng=${currentLng}&date=${dateStr}&formatted=0`;
  const d=await fetchJSON(u,{timeoutMs:10000}); if(d.status!=='OK') throw new Error('Sun API');
  return d.results; // {sunrise, sunset, ...} en ISO UTC
}

async function reverseGeocode(lat,lng){
  const u=`https://nominatim.openstreetmap.org/reverse?format=json&lat=${lat}&lon=${lng}`;
  try{
    const d=await fetchJSON(u,{headers:{
      'User-Agent':'PlanetaryHours/1.0 (+shopify)',
      'Accept-Language': calculatorLocale
    }});
    const a=d.address||{};
    return {
      city: a.city || a.town || a.village || null,
      country: a.country || null,
      country_code: a.country_code || null
    };
  }catch{ return {city:null,country:null,country_code:null}; }
}

/** Timezone IANA par coordonnées. Fallback : fuseau du navigateur. */
async function tzByCoord(lat,lng){
  try{
    const u=`https://timeapi.io/api/TimeZone/coordinate?latitude=${lat}&longitude=${lng}`;
    const d=await fetchJSON(u,{timeoutMs:8000});
    return { timeZone: d.timeZone || null };
  }catch{
    return { timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone };
  }
}

// ====== UI ================================================================
function showSkeleton(c, n){
  c.setAttribute('aria-busy','true'); c.innerHTML='';
  const f=document.createDocumentFragment();
  for(let i=0;i<n;i++){
    const el=document.createElement('div'); el.className='hour-card skeleton';
    el.innerHTML=`<div class="hour-symbol"></div><div class="hour-info">
      <p class="hour-name" style="background:#ccc;width:80%;height:1em;margin-bottom:0.5em;"></p>
      <p class="hour-slot" style="background:#ccc;width:60%;height:1em;"></p></div>`;
    f.appendChild(el);
  }
  c.appendChild(f);
}

function animateSwap(c, cards){
  const cur=[...c.children]; cur.reverse().forEach((el,i)=>{el.style.animationDelay=`${i*0.06}s`; el.classList.add('fade-out-up');});
  const delay=(cur.length?((cur.length-1)*0.06+0.4):0)*1000;
  setTimeout(()=>{
    c.innerHTML=''; const f=document.createDocumentFragment();
    cards.forEach((el,i)=>{ el.style.animationDelay=`${i*0.06}s`; el.classList.add('fade-in-down'); f.appendChild(el); });
    c.appendChild(f); c.setAttribute('aria-busy','false');
  }, delay);
}

function createHourCards({ startUtc, hourMs, startIndex, isToday, nowLocalMs }){
  const out=[];
  for(let i=0;i<12;i++){
    const sUtc=new Date(startUtc.getTime()+i*hourMs);
    const eUtc=new Date(startUtc.getTime()+(i+1)*hourMs);
    const sLoc=toZoned(sUtc, TARGET_TZ);
    const eLoc=toZoned(eUtc, TARGET_TZ);

    const p=planets[(startIndex+i)%7];
    const active=isToday && nowLocalMs>=sLoc.getTime() && nowLocalMs<eLoc.getTime();

    const el=document.createElement('div'); el.className='hour-card'; el.setAttribute('role','article');
    el.innerHTML=`
      <span class="hour-symbol ${active?'active':''}" aria-hidden="true">${p.symbol}</span>
      <div class="hour-info">
        <p class="hour-name">${ordinalHour(i+1)} - ${p.name}</p>
        <p class="hour-slot">
          <strong>UTC :</strong> ${fmtTime(sUtc,'UTC')} - ${fmtTime(eUtc,'UTC')}<br>
          <strong>${TARGET_COUNTRY} :</strong> ${fmtTime(sUtc,TARGET_TZ)} - ${fmtTime(eUtc,TARGET_TZ)}
        </p>
      </div>`;
    out.push(el);
  }
  return out;
}

// ====== Contrôleur principal ==============================================
async function updatePlanetaryHours(dateStr, trigger = 'initial'){
  const dayC=document.getElementById('day-hours');
  const nightC=document.getElementById('night-hours');
  const sunElt=document.getElementById('sun-times');
  const rulingElt=document.getElementById('ruling-display');

  showSkeleton(dayC,12); showSkeleton(nightC,12);

  try{
    // Données soleil (UTC)
    const [today,next]=await Promise.all([fetchSun(dateStr), fetchSun(nextDateStr(dateStr))]);
    const sunriseUtc=new Date(today.sunrise);
    const sunsetUtc =new Date(today.sunset);
    const nextSunriseUtc=new Date(next.sunrise);

    // Durées
    const dayMs   = Math.max(0, sunsetUtc - sunriseUtc);
    const nightMs = Math.max(0, nextSunriseUtc - sunsetUtc);
    const dayHour = dayMs/12, nightHour = nightMs/12;

    // Détermination du régent du jour selon le fuseau COURANT (TARGET_TZ)
    // On prend le "milieu de journée" local pour être indépendants du lever/coucher.
    const noonUtc = new Date(dateStr + 'T12:00:00Z');       // 12:00 UTC
    const noonLoc = toZoned(noonUtc, TARGET_TZ);            // converti dans TARGET_TZ
    const weekdayLocal = noonLoc.getDay();                  // jour local
    const rulingId = dayRuling[weekdayLocal];
    const rulingIndex = planets.findIndex(p=>p.id===rulingId);
    const rulingName = planets[rulingIndex].name;
    const rulingSymbol= planets[rulingIndex].symbol;

    // Header : régent + lever/coucher (affichés en UTC + local fuseau courant)
    rulingElt.textContent = `${calculatorI18n.rulingDay} (${TARGET_TZ}) : ${rulingName} ${rulingSymbol}`;
    sunElt.textContent = `${calculatorI18n.sunTimes.sunrise} : ${fmtTime(sunriseUtc,'UTC')} ${calculatorI18n.utc} / ${fmtTime(sunriseUtc,TARGET_TZ)} ${TARGET_COUNTRY} • `
                       + `${calculatorI18n.sunTimes.sunset} : ${fmtTime(sunsetUtc,'UTC')} ${calculatorI18n.utc} / ${fmtTime(sunsetUtc,TARGET_TZ)} ${TARGET_COUNTRY}`;

    // “Maintenant” en fuseau courant pour surbrillance
    const nowLocalMs = toZoned(new Date(), TARGET_TZ).getTime();
    const isToday = (new Date().toISOString().split('T')[0]===dateStr);

    const dayCards  = createHourCards({ startUtc:sunriseUtc, hourMs:dayHour,  startIndex:rulingIndex,     isToday, nowLocalMs });
    const nightCards= createHourCards({ startUtc:sunsetUtc,  hourMs:nightHour,startIndex:rulingIndex+12,  isToday, nowLocalMs });

    animateSwap(dayC, dayCards);
    animateSwap(nightC, nightCards);

    publishNexusEvent('nexus:planetary_calculator_use', {
      date: dateStr,
      timezone: TARGET_TZ,
      country: TARGET_COUNTRY,
      city: TARGET_CITY,
      locale_code: calculatorLocale || window.Shopify?.locale || 'fr',
      trigger,
      ruling_planet: rulingId,
      sunrise_utc: sunriseUtc.toISOString(),
      sunset_utc: sunsetUtc.toISOString()
    });
  }catch(e){
    console.error(e);
    dayC.innerHTML = `<p role="alert">${calculatorI18n.error}</p>`;
    nightC.innerHTML = '';
    dayC.setAttribute('aria-busy','false'); nightC.setAttribute('aria-busy','false');
  }
}

// ====== Géoloc + maj fuseau/pays ==========================================
async function updateLocationDisplay(txt){
  const el=document.getElementById('location-display');
  el.textContent = txt;
}

async function geolocateUser(){
  const btn=document.getElementById('geolocate-button');
  const icon=btn.querySelector('.icon-container');
  btn.disabled=true; icon.classList.add('loading');

  if(!navigator.geolocation){ btn.disabled=false; icon.classList.remove('loading'); return; }

  navigator.geolocation.getCurrentPosition(async pos=>{
    currentLat=pos.coords.latitude; currentLng=pos.coords.longitude;

    const geo = await reverseGeocode(currentLat,currentLng);
    TARGET_CITY = geo.city || null;
    TARGET_COUNTRY = geo.country || TARGET_COUNTRY;

    // Mise à jour du fuseau selon coordonnées
    const tz = await tzByCoord(currentLat,currentLng);
    if (tz.timeZone) TARGET_TZ = tz.timeZone;

    await updateLocationDisplay(`${calculatorI18n.location} : ${geo.city || calculatorI18n.place} — ${TARGET_COUNTRY} (${currentLat.toFixed(4)}, ${currentLng.toFixed(4)})`);

    const dateInput=document.getElementById('date-input');
    await updatePlanetaryHours(dateInput.value, 'geolocation');

    btn.disabled=false; icon.classList.remove('loading');
  }, err=>{
    console.error('Géoloc KO', err);
    btn.disabled=false; icon.classList.remove('loading');
  }, { enableHighAccuracy:false, maximumAge:600000, timeout:10000 });
}

// ====== Init ============================================================== 
document.addEventListener('DOMContentLoaded', ()=>{
  const dateInput=document.getElementById('date-input');
  const t=new Date(); const yyyy=t.getFullYear(); const mm=String(t.getMonth()+1).padStart(2,'0'); const dd=String(t.getDate()).padStart(2,'0');
  dateInput.value=`${yyyy}-${mm}-${dd}`;

  updatePlanetaryHours(dateInput.value, 'initial');
  dateInput.addEventListener('change', e=> updatePlanetaryHours(e.target.value, 'date_change'));
  document.getElementById('geolocate-button').addEventListener('click', geolocateUser);

  document.getElementById('day-hours')?.setAttribute('aria-live','polite');
  document.getElementById('night-hours')?.setAttribute('aria-live','polite');
});
